<template lang="pug">
  .thumb(:class="{ enter: !isClick }")
    span.menu-label {{paper.conference}}
    a(:style="{ 'background-image': 'url(' + paper.image + ')',  }" :class="{ flip: isClick }")
      span {{paper.title}}
</template>

<script>
export default {
  name: 'Thumb',
  data () {
    return {
    }
  },
  props: {
    paper: Object,
    isClick: Boolean
  }
}
</script>

<style lang="sass">
  .enter
    &:hover
      a
        transform: translateY(10px) rotateX(70deg)
        &::before
          transform: rotateX(0deg) translateZ(-70px)
          box-shadow: 0 0 7px 7px rgba(black, 1)
          background-color: rgba(black,1)
          transform-origin: bottom
          opacity: 0.15
          height: 90%
  .thumb
    width: 88%
    height: 40vh
    max-height: 320px
    margin: 40px auto
    perspective: 1000px
    cursor: pointer
    .flip
      transform: translateY(0px) rotateX(0deg)
      &::before
        transform: rotateX(90deg) translateZ(-50px)
        box-shadow: 0 0 40px 15px rgba(black, 0.8)
        background-color: rgba(black,0.75)
        transform-origin: bottom
        opacity: 0.15
        height: 90%
    a
      display: block
      width: 100%
      height: 100%
      background-size: cover
      background-position: center center
      transform-style: preserve-3d
      transition-duration: .5s
      transform: rotateX(70deg)
      margin-top: 10px
      &::before
        transition-duration: .5s
        content: ''
        position: absolute
        top: 0
        left: 3%
        width: 94%
        height: 100%
        background-color: rgba(black,0.8)
        transform: rotateX(0deg) translateZ(-80px)
        opacity: 0.15
        box-shadow: 0 0 12px 6px rgba(black,0.8)
      &::after
        content: ''
        width: 100%
        height: 42px
        position: absolute
        left: 0
        bottom: 0
        background-color: #444
        border: solid 1px white
        background-size: cover
        background-position: bottom center
        transform: rotateX(90deg)
        transform-origin: bottom
      span
        color: white
        position: absolute
        top: 100%
        left: 0
        width: 100%
        line-height: 38px
        text-align: center
        transform: rotateX(-90deg)
        transform-origin: top
        font-weight: bold
        z-index: 999
</style>



// WEBPACK FOOTER //
// src/components/Thumb.vue